import type { Sticker } from 'cleverev-types'
import { api } from './api'


class StickerAPI {

  public async listStickers(organizationId: string) {
    const result = await api.get<{ stickers: Sticker[]; totalCount: number }>(`/organizations/${organizationId}/stickers?take=9999`) // TODO: implement pagination

    return result.data
  }

  public async get(organizationId: string, stickerId: string) {
    const result = await api.get<{ stickers: Sticker[]; totalCount: number }>(`/organizations/${organizationId}/stickers?take=9999`) // TODO: replace with get

    return result.data.stickers.find(sticker => sticker.id === stickerId)
  }

  public async update(id: string, partialSticker: Partial<Sticker>) {
    console.log(partialSticker)

    const result = await api.post<{ sticker: Sticker }>(
      `/stickers/${id}/update`,
      partialSticker
    )

    return result.data.sticker
  }

  public async create(newSticker: Partial<Sticker>) {
    const result = await api.post<{ sticker: Sticker }>(
      '/stickers',
      newSticker
    )

    return result.data.sticker
  }

  public async delete(id: string) {
    await api.delete(`/stickers/${id}`)

    return null
  }

}

export const stickerAPI = new StickerAPI()
